export class GameLog {
    public Color: string;
    public Date: string;
    public Name: string;
    public State: string;
}
